<template> 
   <div>      
        <div>  
               
            <ul class="q_ul bottom10">
                <li class="a1">
                    <div class="flex">
                        <div class="f1">商品</div>
                        <div class="f2"></div>
                        <div class="f3">单价(元)/数量</div>
                    </div>
                </li>
                <li class="a2">孝心值</li>
                <li class="a3">收货人</li>
                <li class="a4">配送方式</li>
                <li class="a5">实收金额(元)</li>
                <li class="a6">订单状态</li>
                <li class="a7">操作</li>
            </ul>

            <div class="">         
                <table class="my_table" v-if="data1.length!=0" >
                    <tbody   v-for='items in data1'  :key="items.guid" >
                        <tr>
                            <td colspan="7">
                                <div class="tTitle goods_bg  goods_border" v-if="items.address">
                                    <div class="flex">      
                                        <div class="padr30 wb fa">
                                            <span class="inline-block wp300">订单号：{{items.orderNumber}}</span>  
                                            <span class="inline-block wp300">下单时间：{{items.createTime}}</span> 
                                        </div>
                                    
                                        <div class="txt_r fb" @click="checkGuid = items.guid;show2()"><a href="#">查看详情</a></div>
                                    </div>
                                </div>
                            </td>
                        </tr>
                        <tr v-for='(item,num2) in items.orderCommodity' :key="num2" >
                            <!-- 商品 单价/数量 -->
                            <td class="a1">
                                <div class="flex pad10 alignItemsC" >
                                    <img class="f1" :src="item.image" alt="">
                                    <div class="f2">
                                        <p>{{item.name}}</p>  
                                        <p>{{item.specsName}}</p>
                                    </div>
                                    <div class="f3">
                                        <p>{{(item.price/100).toFixed(2)}}  <span v-if="items.orderCommodity.length==1"> + {{item.integral}}</span> </p>
                                        <p>{{item.num}}件</p>
                                    </div>
                                </div>        
                            </td>
                            <!-- 孝心值 -->
                           
                            <td class="a2"  :rowspan="items.orderCommodity.length"   v-if="num2 == 0" >      
                                <p v-if="items.orderCommodity.length==1">{{(items.integralPrice/100).toFixed(2)}} (元)</p>
                                <p v-if="items.orderCommodity.length==1">{{items.integral}}</p>

                                <p v-if="items.orderCommodity.length!=1">N/A</p>           
                            </td>
                            <!-- 收货人 -->
                            <td class="a3"   :rowspan="items.orderCommodity.length"  v-if="num2 == 0&&items.address">
                                <p>{{items.address.name}}</p>
                                <p>{{items.address.mobile}}</p>
                            </td>
                            <!-- 配送方式 -->
                            <td class="a4" :rowspan="items.orderCommodity.length"  v-if="num2 == 0">
                                <p>快递</p>
                            </td>
                            <!-- 实收金额 -->
                            <td class="a5" :rowspan="items.orderCommodity.length"  v-if="num2 == 0">
                                <p>{{ (items.totalPrice/100).toFixed(2)}}</p>
                            </td>
                            <!-- 订单状态 -->
                            <td class="a6" :rowspan="items.orderCommodity.length"  v-if="num2 == 0">
                                <p v-if="items.state == 0">待付款</p>
                                <p v-if="items.state == 1">待发货</p>
                                <p v-if="items.state == 2">已发货</p>
                                <p v-if="items.state == 3">交易完成</p>
                                <p v-if="items.state == 4">订单取消</p>
                                <p v-if="items.state == 5">已退款</p>   
                            </td>
                            <!-- 操作 -->
                            <td class="a7 txt_c" :rowspan="items.orderCommodity.length"  v-if="num2 == 0"> 
                                <!-- 待付款：取消订单 ；待发货 发货  -->
                                <!-- <Button type="default" v-if="items.state == 0" @click="btn(0,items.guid)"  >取消订单</Button>  -->
                                <Button type="default" v-if="items.state == 1" @click="btn(1,items.guid)"  > 发货 </Button> 
                                <p v-if=" items.state != 1">N/A</p>
                            </td>  
                        </tr>
                        <tr> <div style="height:10px"></div> </tr>
                    </tbody>
                </table>
            </div>

            <Footer>
                <Page class="txt_c"  :current.sync="page" :page-size-opts=[5,10,15,25,30] :total="all.total" :page-size='size'    @on-change='change_page' @on-page-size-change='change_size' show-total  show-sizer />
            </Footer>
        </div>

   </div>
</template> 
<script>
   
    export default {
        name:'query1',
        data () {
            return {
                state: 0,
                setGuid: null,
                all: {},
                data1: [],

                type2: 0,
                orderNumber: null,
                total: 0,
                page: 1,
                size: 5,
                checkGuid: null,
            }
        },
        watch:{
            type(index){
                this.load();
            }
        },
        props:['type','search'],

        computed: {
           
        },
        methods: {
            load(){
                
                let data = {
                    type: this.orderNumber&&this.type=='6'?'7':this.type,
                    orderNumber: this.type == '6'?this.orderNumber:null,
                    page: this.page,
                    size: this.size
                }
                this.$myAjax.get('admin/service/mail/order/get'+this.$ajaxNull.get(data)).then(res => {
                    this.all = res.data.data;
                    let data = res.data.data.list;
                    this.data1 = data;
                    // console.log(data)
                })

            },
            order_load(){

            },
            btn(n,guid){  //操作 发货
                if(n == 1){
                    let data = {
                        guid: guid,
                        setbool: true,
                        delbool: false
                    }
                    this.$emit('modal1',data);
                }else if(n == 0){

                }
               
            },
            show(){  //点击发货人
                this.$store.commit('change_checkGuid2',this.setGuid);
                // alert(this.$store.state.checkGuid2)
            },
            show2(){
                this.$emit('checkGuid',this.checkGuid);
            },
            change_page(){
                this.load();
            },
            change_size(){
                this.load();
            },
            
            searchFun(e){
                
                this.type2 = 7;
                e? this.orderNumber = e.toString() :  this.orderNumber = e;
                this.load();
            }
        },
        mounted: function(){
            this.type2 = this.type;
            this.load();      
        }
    }
</script>  
<style scoped>
    @import '/css/index.css';
    .wb{
        word-break: keep-all;
    }
    .flex{
        display: flex;
    }
    .q_ul{overflow: hidden;background: #f7f8fa;}
    .q_ul li{
        float:left;
        padding: 15px 10px;
    }
    .q_ul li:not(.a1){
        text-align: center;
    }
    
    
    .a1{width:34%;}
    .a2,.a3,.a4,.a5,.a6,.a7{width:11%;}
    
    
    table{width: 100%;}
    tr{width: 100%;}
    td{align-items: center;border: 1px solid #ebedf0;}
    .tTitle{   
        border-bottom: 0;
        padding: 16px;
        color: #323233;
    }

    .f1{
        width: 60px;
        margin-right: 10px;  
    }
    td .f1{
        height: 60px;
        border-radius: 3px;
    }
    .f2{
        margin-right: 10px; 
        flex-grow: 1;  
    }
    .f3{
        min-width: 120px;
        text-align: right;
    }
    
    td:not(.a1) p{
        text-align: center;
    }
    .fa{
        flex: 2;
    }
    .fb{
        flex: 1;
    }
</style>
